// src/pages/client/Filtres.jsx
import React, { useState } from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';
import { Link } from 'react-router-dom';
import CalltoAction from '../../components/client/CalltoAction';


const Filtres = () => {
  const [searchValue, setSearchValue] = useState("Jean Dupont");
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = () => {
    setIsSearching(true);
    setTimeout(() => setIsSearching(false), 1500);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />

      {/* Section Hero avec texte à gauche et Search Demo à droite */}
      <div className="py-16 bg-gradient-to-r from-slate-800 to-slate-900">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Texte à gauche */}
            <div className='text-white animate-[slideInLeft_1s_ease-out]'>
              <div className='mb-6'>
                <h1 className="text-5xl font-bold mb-6 leading-tight">
                  Filtres Avancés
                </h1>
              </div>
              <div className='mb-8'>
                <p className="text-xl leading-relaxed opacity-90">
                  Trouvez le candidat parfait en quelques secondes grâce à notre système de recherche et filtrage intelligent
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to='/contact'>
                  <button className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-700 hover:scale-105 transition-all duration-300 hover:shadow-lg">
                    Commencer gratuitement
                  </button>
                </Link>
              </div>
            </div>
            
            {/* Search Demo redesigné */}
            <div className="animate-[slideInRight_1.2s_ease-out]">
              <div className="bg-white rounded-2xl shadow-2xl overflow-hidden backdrop-blur-sm border border-white/20 hover:shadow-3xl transition-all duration-500 hover:scale-105">
                
                {/* Header de la demo */}
                <div className="bg-gradient-to-r from-indigo-600 to-blue-600 p-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-white font-semibold flex items-center">
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                      Recherche Intelligente
                    </h3>
                    <div className="flex space-x-1">
                      <div className="w-3 h-3 bg-white/30 rounded-full"></div>
                      <div className="w-3 h-3 bg-white/30 rounded-full"></div>
                      <div className="w-3 h-3 bg-white/30 rounded-full"></div>
                    </div>
                  </div>
                </div>

                {/* Contenu de la demo */}
                <div className="p-6 space-y-6">
                  
                  {/* Première ligne de filtres */}
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-slate-700">
                        <svg className="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        Recherche par nom
                      </label>
                      <div className="relative group">
                        <input 
                          type="text" 
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          placeholder="Nom du candidat..." 
                          className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 group-hover:border-indigo-400"
                        />
                        <svg className="absolute right-3 top-3 w-5 h-5 text-slate-400 group-hover:text-indigo-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                      </div>
                    </div>
                    
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-slate-700">
                        <svg className="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                        Entreprise
                      </label>
                      <input 
                        type="text" 
                        placeholder="Entreprise actuelle..." 
                        className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 hover:border-indigo-400"
                        defaultValue="Google"
                      />
                    </div>
                  </div>

                  {/* Process selector */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-slate-700">
                      <svg className="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                      Process en cours
                    </label>
                    <select className="w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 hover:border-indigo-400">
                      <option>Data Analyst - Voodoo</option>
                      <option>CSM Senior - Dawex</option>
                      <option>Tech Lead React Node - Saegus</option>
                    </select>
                  </div>
                  
                  {/* Tags section avec animation */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-slate-700">
                      <svg className="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a1.994 1.994 0 01-1.414.586H7a4 4 0 01-4-4V7a4 4 0 014-4z" />
                      </svg>
                      Tags
                    </label>
                    <div className="flex flex-wrap gap-2">
                      <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm hover:bg-blue-200 transition-colors cursor-pointer hover:scale-105 transform duration-200">
                        React
                      </span>
                      <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm hover:bg-green-200 transition-colors cursor-pointer hover:scale-105 transform duration-200">
                        Senior
                      </span>
                      <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm hover:bg-purple-200 transition-colors cursor-pointer hover:scale-105 transform duration-200">
                        JavaScript
                      </span>
                      <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm hover:bg-orange-200 transition-colors cursor-pointer hover:scale-105 transform duration-200 flex items-center">
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                        </svg>
                      </span>
                    </div>
                  </div>

                  {/* Bottom section avec checkbox et bouton */}
                  <div className="flex items-center justify-between pt-4 border-t border-slate-200">
                    <label className="flex items-center space-x-2 cursor-pointer group">
                      <div className="relative">
                        <input type="checkbox" className="sr-only" defaultChecked />
                        <div className="w-5 h-5 bg-indigo-600 rounded border-2 border-indigo-600 flex items-center justify-center group-hover:bg-indigo-700 transition-colors">
                          <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </div>
                      </div>
                      <span className="text-sm text-slate-700 group-hover:text-slate-900 transition-colors">
                        <svg className="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21L6.2 11.25a11.042 11.042 0 005.55 5.55l1.863-4.024a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                        Avec téléphone
                      </span>
                    </label>
                    
                    <button 
                      onClick={handleSearch}
                      disabled={isSearching}
                      className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-2 rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-300 hover:scale-105 hover:shadow-lg flex items-center space-x-2 disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      {isSearching ? (
                        <>
                          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          <span>Recherche...</span>
                        </>
                      ) : (
                        <>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                          <span>Rechercher (247 résultats)</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>

                {/* Barre de résultats animée */}
                {isSearching && (
                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 border-t">
                    <div className="flex items-center space-x-3">
                      <div className="flex space-x-1">
                        <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce"></div>
                        <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                        <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
                      </div>
                      <span className="text-sm text-indigo-700">Analyse en cours...</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Interface Demo */}
      <div className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-800 mb-4">
              Interface de Recherche Intuitive
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Combinez plusieurs critères pour affiner votre recherche
            </p>
          </div>

          {/* Filter Types */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl hover:scale-105 hover:-translate-y-2 transition-all duration-300">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Recherche Textuelle</h3>
              <p className="text-slate-600">
                Recherchez par nom, entreprise, poste ou toute information textuelle avec notre moteur de recherche intelligent.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl hover:scale-105 hover:-translate-y-2 transition-all duration-300">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a1.994 1.994 0 01-1.414.586H7a4 4 0 01-4-4V7a4 4 0 014-4z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Filtres par Tags</h3>
              <p className="text-slate-600">
                Utilisez notre système de tags pour catégoriser et retrouver rapidement vos candidats par compétences.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl hover:scale-105 hover:-translate-y-2 transition-all duration-300">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Géolocalisation</h3>
              <p className="text-slate-600">
                Filtrez par ville pour trouver des candidats dans la zone géographique souhaitée.
              </p>
            </div>
          </div>

        </div>
        <CalltoAction/>

      </div>

      <Footer />
    </div>
  );
};

export default Filtres;